import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetTransferToEvaluator = createAsyncThunk(
  "GetTransferToEvaluator/GetTransferToEvaluator",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/TransferToEvaluator",
        parameters
      );

      const data = response.data.result;
      console.log(data, "app");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const TransferToEvaluator = createSlice({
  name: "TransferToEvaluator",
  initialState: {
    TransferToEvaluator: [],
    loadingTransferToEvaluator: false,
    errorTransferToEvaluator: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetTransferToEvaluator.pending, (state, action) => {
        state.loadingTransferToEvaluator = true;
        state.TransferToEvaluator = action.payload;
        state.errorTransferToEvaluator = null;
      })
      .addCase(GetTransferToEvaluator.fulfilled, (state, action) => {
        state.loadingTransferToEvaluator = false;
        state.TransferToEvaluator = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetTransferToEvaluator.rejected, (state, action) => {
        state.loadingTransferToEvaluator = false;
        state.errorTransferToEvaluator = action.payload;
      });
  },
});

export default TransferToEvaluator.reducer;
